// src/pages/transaction-details.page.tsx
import React from 'react';
import { Container, Alert } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { TransactionStatus } from '../../enum/transaction-status.enum';
import { DetailedTransaction } from '../interfaces/transaction-details.interface';
import TransactionCard from '../components/transaction-card.component';


const TransactionDetails: React.FC = () => {
  const location = useLocation();
  const transactionDetails = location.state as DetailedTransaction;
  if (!transactionDetails) {
    return <h4>No transaction details found.</h4>;
  }

  const { status, message } = transactionDetails;

  // Determine Alert style and Badge color based on status
  const alertVariant =
    status === TransactionStatus.Successful
      ? 'success'
      : status === TransactionStatus.Pending
        ? 'warning'
        : 'danger';
  const alertMessage =
    status === TransactionStatus.Successful
      ? 'Your transaction was successful!'
      : status === TransactionStatus.Pending
        ? 'Your transaction is currently pending.'
        : 'Your transaction has failed.';

  return (
    <Container className="mt-5">
      {/* Transaction status Alert */}
      <Alert variant={alertVariant} className="text-center">
        <strong>{alertMessage}</strong>
        {message && <div className="mt-2 text-danger">{message}</div>}
      </Alert>

      <TransactionCard transaction={transactionDetails} onClick={() => null} />
    </Container>
  );
};

export default TransactionDetails;